import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { Eyebrow } from './ui/Eyebrow';
import { comparison } from '../data/content';
export function BeforeAfterSection() {
  return <section className="border-b border-line bg-cream" data-id="element-1" data-mp="pnipu1m27sbp">
      <div className="mx-auto max-w-6xl px-5 py-20 lg:py-24" data-id="element-2" data-mp="pp3jzq4gp991">
        <div className="max-w-2xl" data-id="element-3" data-mp="kwtz4oi7ezdm">
          <Eyebrow data-id="element-4" data-mp="kvr72d95aqw4">Antes vs. después</Eyebrow>
          <h2 className="mt-4 font-display text-3xl font-semibold leading-tight text-ink sm:text-4xl" data-id="element-5" data-mp="zlgl392c6pdt">
            Dejá de improvisar. Empezá a enseñar con un sistema.
          </h2>
          <p className="mt-5 text-[15px] leading-relaxed text-ink-soft" data-id="element-6" data-mp="18mob73up8jwt">
            La misma clase, con y sin el pack de El Profe de Guitarra.
          </p>
        </div>

        <div className="mt-12 overflow-hidden rounded-2xl border border-line bg-paper" data-id="element-7" data-mp="13lh0avx9f4lx">
          <div className="grid grid-cols-1 sm:grid-cols-2" data-id="element-8" data-mp="3ae9phatkzezb">
            <p className="border-b border-line px-6 py-4 text-[11px] font-semibold uppercase tracking-eyebrow text-ink-mute sm:border-r" data-id="element-9" data-mp="35fq1z5zc9v4u">
              Sin El Profe de Guitarra
            </p>
            <p className="hidden border-b border-line bg-accent-soft px-6 py-4 text-[11px] font-semibold uppercase tracking-eyebrow text-accent-dark sm:block" data-id="element-10" data-mp="3bn389kb7sgb8">
              Con El Profe de Guitarra
            </p>
          </div>

          <ul data-id="element-11" data-mp="3le7jqa1olj1b">
            {comparison.map(row => <li key={row.without} className="grid grid-cols-1 border-b border-line last:border-b-0 sm:grid-cols-2" data-id="element-12" data-mp="3pf9laxj2m76g">
                <div className="flex items-start gap-3 px-6 py-5 sm:border-r sm:border-line" data-id="element-13" data-mp="3udb5xmw5aek1">
                  <XIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-ink-mute" data-id="element-14" data-mp="37jhcry0n9zc" />
                  <span className="text-[15px] leading-relaxed text-ink-mute line-through decoration-ink-mute/40" data-id="element-15" data-mp="875vr4pkyw9q">
                    {row.without}
                  </span>
                </div>
                <div className="flex items-start gap-3 bg-accent-soft/50 px-6 py-5" data-id="element-16" data-mp="29xr34dee4wcv">
                  <CheckIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-accent" data-id="element-17" data-mp="21xbavwyoglpb" />
                  <span className="text-[15px] font-medium leading-relaxed text-ink" data-id="element-18" data-mp="1wyq93t3s1tyr">
                    {row.with}
                  </span>
                </div>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}